module.exports = __webpack_public_path__ + "static/media/golden_raspberry.af9bec87.png";